import { File } from './../../models/files/files.model';

export class Sponsored {
    id?: string;
    title?: any;
    content?: any;
    file?: File;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.content = options.content;
        this.file = options.file;
    }
}
